import { render } from "./Invoice.vue?vue&type=template&id=061eb31e&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=061eb31e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061eb31e"],['__file',"src/views/Invoices/Invoice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "061eb31e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('061eb31e', __exports__)) {
    api.reload('061eb31e', __exports__)
  }
  
  module.hot.accept("./Invoice.vue?vue&type=template&id=061eb31e&scoped=true", () => {
    api.rerender('061eb31e', render)
  })

}


export default __exports__